export interface BrandingConfig {
    projectName: string;
    favicon: string;
    header_logo: string;
    footer_logo: string;
    primaryColor: string;
    secondaryColor: string;
    footer: {
        title: string;
        copyright: string;
        address: string;
        postalCode: string;
        email: string;
        socialMedia: {
            facebook: string;
            instagram: string;
            linkedin: string;
            youtube: string;
        }
    }
}

export const BRANDING: Record<string, BrandingConfig> = {
    talentum: {
        projectName: "Soporte Talentum",
        favicon: "/images/talentum/favicon.ico",
        header_logo: "/images/talentum/logo.png",
        footer_logo: "/images/talentum/logo.png",
        primaryColor: "#1a237e",
        secondaryColor: "#ffffff",
        footer: {
            title: "Soporte Talentum",
            copyright: "Todos los derechos reservados Talentum Corp 2025",
            address: "Cl. 7 #26 - 42, 3 de Julio, Cali, Valle del Cauca",
            postalCode: "760042",
            email: "contact@talentum.edu.co",
            socialMedia: {
                facebook: "https://www.facebook.com/CorpTalentum",
                instagram: "https://www.instagram.com/corptalentum/",
                linkedin: "https://www.linkedin.com/company/corptalentum/",
                youtube: "https://www.youtube.com/@corporaciontalentum"
            }
        }
    },
    portal_pacifico: {
        projectName: "Soporte Portal Pacífico",
        favicon: "/images/pacifico/favicon.ico",
        header_logo: "/images/pacifico/logo-pacifico-colombia.svg",
        footer_logo: "/images/pacifico/logo-pacifico-colombia-vertical.svg",
        primaryColor: "#f8f8f8",
        secondaryColor: "#2158A4",
        footer: {
            title: "Soporte Región Pacífico",
            copyright: "Todos los derechos reservados 2025 - Turismo Región Pacífico",
            address: "Calle 21 Norte con avenida 5B # 21N - 02, Barrio Versalles",
            postalCode: "760045",
            email: "contactenos@rap-pacifico.gov.co",
            socialMedia: {
                facebook: "https://www.facebook.com/rapacifico",
                instagram: "https://www.instagram.com/rapacifico/",
                linkedin: "https://www.linkedin.com/company/rap-pacifico/",
                youtube: "https://www.youtube.com/channel/UCkB8oZ_gIWdw8u-BTTy9UAA"
            }
        }
    },
    hevequi: {
        projectName: "Soporte Hevequi",
        favicon: "",
        header_logo: "/images/hevequi/logo.png",
        footer_logo: "/images/hevequi/logo.png",
        primaryColor: "#1a237e",
        secondaryColor: "#ffffff",
        footer: {
            title: "Soporte Hevequi",
            copyright: "Todos los derechos reservados a Hevequi",
            address: "Cra 32 # 12 - Parque industrial",
            postalCode: "760002",
            email: "+57 602 312 0598",
            socialMedia: {
                facebook: "https://www.facebook.com/CorpHevequi",
                instagram: "https://www.instagram.com/corphevequi/",
                linkedin: "https://www.linkedin.com/company/corphevequi/",
                youtube: "https://www.youtube.com/@corporacionhevequi"
            }
        }
    },
    bilinguismo_valle: {
        projectName: "Soporte Bilingüismo Valle",
        favicon: "/images/bilinguismo/favicon.ico",
        header_logo: "/images/bilinguismo-valle/valle-bilingue.png",
        footer_logo: "/images/bilinguismo-valle/valle-bilingue.png",
        primaryColor: "#F7941D",
        secondaryColor: "#ffffff",
        footer: {
            title: "Soporte Bilingüismo Valle",
            copyright: "Todos los derechos reservados Talentum Corp 2025",
            address: "Cl. 7 #26 - 42, 3 de Julio, Cali, Valle del Cauca",
            postalCode: "760042",
            email: "contact@talentum.edu.co",
            socialMedia: {
                facebook: "https://www.facebook.com/CorpTalentum",
                instagram: "https://www.instagram.com/corptalentum/",
                linkedin: "https://www.linkedin.com/company/corptalentum/",
                youtube: "https://www.youtube.com/@corporaciontalentum"
            }
        }
    },
    aulas_sai: {
        projectName: "Soporte Aulas SAI",
        favicon: "/images/aulas-sai/favicon.ico",
        header_logo: "/images/aulas-sai/logo.png",
        footer_logo: "/images/aulas-sai/logo.png",
        primaryColor: "#5EC7FA",
        secondaryColor: "#00417C",
        footer: {
            title: "Soporte Talentum",
            copyright: "Todos los derechos reservados Talentum Corp 2025",
            address: "Cl. 7 #26 - 42, 3 de Julio, Cali, Valle del Cauca",
            postalCode: "760042",
            email: "contact@talentum.edu.co",
            socialMedia: {
                facebook: "https://www.facebook.com/CorpTalentum",
                instagram: "https://www.instagram.com/corptalentum/",
                linkedin: "https://www.linkedin.com/company/corptalentum/",
                youtube: "https://www.youtube.com/@corporaciontalentum"
            }
        }
    },
    turismo_sai: {
        projectName: "Soporte Turismo SAI",
                favicon: "/images/aulas-sai/favicon.ico",
        header_logo: "/images/aulas-sai/logo.png",
        footer_logo: "/images/aulas-sai/logo.png",
        primaryColor: "#5EC7FA",
        secondaryColor: "#00417C",
        footer: {
            title: "Soporte Talentum",
            copyright: "Todos los derechos reservados Talentum Corp 2025",
            address: "Cl. 7 #26 - 42, 3 de Julio, Cali, Valle del Cauca",
            postalCode: "760042",
            email: "contact@talentum.edu.co",
            socialMedia: {
                facebook: "https://www.facebook.com/CorpTalentum",
                instagram: "https://www.instagram.com/corptalentum/",
                linkedin: "https://www.linkedin.com/company/corptalentum/",
                youtube: "https://www.youtube.com/@corporaciontalentum"
            }
        }
    },
    peer: {
        projectName: "Soporte PEER",
		favicon: "/images/peer/favicon.ico",
        header_logo: "/images/peer/logo.png",
        footer_logo: "/images/peer/logo.png",
        primaryColor: "#005d84",
        secondaryColor: "#ffffff",
        footer: {
            title: "Soporte PEER",
            copyright: "Todos los derechos reservados Talentum Corp 2025",
            address: "Calle 1A # 55B - 97, Cali, Colombia",
            postalCode: "760010",
            email: "comunicaciones@fundacionnuevohorizonte.edu.co",
            socialMedia: {
                facebook: "https://www.facebook.com/FundacionNuevoHorizonteCol",
                instagram: "https://www.instagram.com/fundacionnuevohorizontecol",
                linkedin: "",
                youtube: "http://www.youtube.com/@fundacionnuevohorizontecol"
            }
        }
    }
};